// eslint-disable-next-line import/no-cycle
import { AxiosPromise } from 'axios';
import { projectRequest } from 'store/utils/request';
import { EnvironmentItem } from 'scenes/ProjectSettings/scenes/Environments/EnvironmentsList/Environment/types';

interface EnvironmentsListResponse {
  count: number;
  results: EnvironmentItem[];
}

export const createEnvironmentRequest = (
  name: string,
  url: string,
  username: string,
  applicationName: string,
  isDefault: boolean = false,
): AxiosPromise<EnvironmentItem> =>
  projectRequest.post('/environments/', {
    name,
    url,
    username,
    app_name: applicationName,
    default: isDefault,
  });

export const getEnvironmentsListRequest = (): AxiosPromise<EnvironmentsListResponse> =>
  projectRequest.get('/environments/');

export const deleteEnvironmentRequest = (envId: string): AxiosPromise =>
  projectRequest.delete(`/environments/${envId}/`);

export const updateEnvironmentRequest = (
  id: string,
  name: string,
  url: string,
  username: string,
  applicationName: string,
  isDefault: boolean = false,
): AxiosPromise<EnvironmentItem> =>
  projectRequest.put(`/environments/${id}/`, {
    name,
    url,
    username,
    app_name: applicationName,
    default: isDefault,
  });

export const setDefaultEnvironmentRequest = (
  envId: string,
  setDefault: boolean,
): AxiosPromise<EnvironmentItem> =>
  projectRequest.patch(`/environments/${envId}`, { default: setDefault });
